exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-755d31d5] .pay-code .el-image__inner{width:inherit}", ""]);

// exports
